import { useState } from "react";
import { Download, Loader2, Check } from "lucide-react";
import { api, formatApiError } from "../lib/api";

export default function LeadMagnetForm() {
  const [firstName, setFirstName] = useState("");
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState({ state: "idle", message: "" });
  const [downloadUrl, setDownloadUrl] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setStatus({ state: "loading", message: "" });
    try {
      const { data } = await api.post("/lead-magnet/quick-start", { first_name: firstName, email });
      setDownloadUrl(data.download_url);
      setStatus({ state: "success", message: data.message });
    } catch (err) {
      setStatus({ state: "error", message: formatApiError(err.response?.data?.detail) || "Something went wrong. Please try again." });
    }
  };

  if (status.state === "success") {
    return (
      <div data-testid="leadmagnet-success" className="border border-primary/40 bg-primary/5 p-6">
        <div className="flex items-center gap-2 text-primary">
          <Check className="h-5 w-5" /><span className="font-display text-lg">Check your inbox</span>
        </div>
        <p className="mt-2 text-sm text-foreground/65 leading-relaxed">We just emailed your Toolkit and subscribed you to Greenpapers. You can also download it right now:</p>
        <a data-testid="leadmagnet-download" href={downloadUrl} rel="noopener" download
          className="mt-4 inline-flex items-center gap-2 bg-primary text-primary-foreground text-sm font-medium px-5 py-3 hover:bg-primary-hover transition-colors">
          <Download className="h-4 w-4" /> Download the Toolkit (PDF)
        </a>
      </div>
    );
  }

  return (
    <form onSubmit={submit} data-testid="leadmagnet-form" className="border border-border bg-surface/60 p-6">
      <p className="font-display text-lg">Get the printable Toolkit</p>
      <p className="mt-1 text-sm text-foreground/55 leading-relaxed">Enter your email and we'll send the PDF and subscribe you to Greenpapers. Unsubscribe anytime.</p>
      <div className="mt-4 grid sm:grid-cols-2 gap-3">
        <input data-testid="leadmagnet-name" value={firstName} onChange={(e) => setFirstName(e.target.value)}
          placeholder="First name (optional)" className="bg-base border border-border px-4 py-3 text-sm text-foreground placeholder:text-muted-foreground focus:border-primary focus:outline-none transition-colors" />
        <input data-testid="leadmagnet-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
          placeholder="you@email.com" className="bg-base border border-border px-4 py-3 text-sm text-foreground placeholder:text-muted-foreground focus:border-primary focus:outline-none transition-colors" />
      </div>
      {status.state === "error" && <p data-testid="leadmagnet-error" className="mt-3 text-xs text-destructive">{status.message}</p>}
      <button type="submit" disabled={status.state === "loading"} data-testid="leadmagnet-submit"
        className="mt-4 w-full inline-flex items-center justify-center gap-2 bg-primary text-primary-foreground text-sm font-medium px-6 py-3.5 hover:bg-primary-hover transition-colors disabled:opacity-60 shadow-[0_0_20px_rgba(0,229,153,0.3)]">
        {status.state === "loading" ? <><Loader2 className="h-4 w-4 animate-spin" /> Sending</> : <><Download className="h-4 w-4" /> Email me the Toolkit</>}
      </button>
    </form>
  );
}
